module.exports = __webpack_public_path__ + "static/media/man1.081cf72b.jpg";